export default {
    AGUARDANDO_ENVIO: 'Aguardando Envio',
    ANALISADA: 'Analisada',
    ENTREGUE: 'Entregue'
}
